angular.module('ui.centre.overview', ['kendo.directives', 'nvd3'])

    .config(function ($stateProvider) {
        $stateProvider.state('client.centre', {
            url: '/centres/:centreId/overview',
            templateUrl: 'app/ui/centre/overview/overview.html',
            controller: 'CentreOverviewController',
            controllerAs: 'CentreOverviewController',
            data: { pageTitle: 'OrderManager: Centre Overview' },
            resolve: {
                currentUser: function (usersRepository) {
                    return usersRepository.getCurrentUser();
                }
            }
        });
    })

    .controller('CentreOverviewController', function ($window, $compile, $timeout, $rootScope, $scope, $state, $log, $q, gettext, uiLocalization, toastr, usersRepository,
        appLocale, rest, authService, currentUser, serverLocalization, centresRepository, ordersRepository, centreOverviewUpdatesService, geocodingService, workflowRepository, 
        gridDataProvider, templateResolver, orderItemsGridSharedSettings, customResourceResolver, reportManager) {

        var textSearchTrigger = false;
        var dataRequestCount = 0;
        const UsersStatsChartTypes = Object.makeEnum(["year", "month", "week"]);
        
        $scope.user = currentUser;
        $scope.centreId = $state.params.centreId;
        $scope.centre = null;
        $scope.centreOrders = [];
        $scope.permissionsGranted = false;

        $scope.usersStatsTo = new Date();
        $scope.usersStatsFrom = new Date().addDays(-7);
        $scope.userStatsChartType = UsersStatsChartTypes.week;
        
        _.extend($scope, {
            setBusyState: setBusyState,
            applyTextSearch: applyTextSearch,
            viewUsersActivityLastYear: viewUsersActivityLastYear,
            viewUsersActivityLastMonth: viewUsersActivityLastMonth,
            viewUsersActivityLastWeek: viewUsersActivityLastWeek,
            setCurrentTab: setCurrentTab
        });

        initController();

        function initController() {
            $scope.isBusy = true;

            //clear any remembered search filter 
            if (!$state.params.search) {
                orderItemsGridSharedSettings.setTextSearch(null);
            }

            //clear any remembered selected items if we re-visit the items grid
            orderItemsGridSharedSettings.setSelectedOrderItemIds([]);

            checkCurrentUserPermissions()
                .then(function(granted) {
                    if (granted) {
                        $q.all([initPageHeaderAndConfigs(), getCentreStatistics()])
                            .then(function(result) {

                                getAddressGeocodingData();

                                //Init watchers to watch for order changes and reload data
                                initWatchers();

                                //Init customer's orders grid
                                initAdditionalFilter();
                                initGrid();
                                initReportList();
                            })
                            .then(function() {
                                $scope.isBusy = false;
                            });

                    } else {
                        //otherwise do nothing
                        $scope.isBusy = false;
                    }
                })
                .catch(function(error) {
                    $log.error("Can't initialize centre orders data & grid.");
                    if (error && error.message) {
                        $log.error(error.message);
                        toastr.error(uiLocalization.translate("Data request failed. Error: %s", error.message));
                    } else if (error && _.isString(error)) {
                        $log.error(error);
                        toastr.error(uiLocalization.translate("Data request failed. Error: %s", error));
                    } else if (error && error.status) {
                        toastr.error(uiLocalization.translate("Data request failed. Error %s : %s",
                            error.status,
                            error.statusText));
                    } else {
                        toastr.error(gettext("Data request failed"), gettext("Server is not responding"));
                    }
                });
        }

        function initWatchers() {

            var reloadGridBySignalREvent = _.debounce(function (e) {
                reloadGrid();
                getCentreStatistics(); 
            }, 1000);

            // Watchers are not enabled for now to make less load on server
            // 
            //centreOverviewUpdatesService.onOrderItemChanged(reloadGridBySignalREvent);
            //centreOverviewUpdatesService.onOrderChanged(reloadGridBySignalREvent);
            //centreOverviewUpdatesService.onNewOrderItem(reloadGridBySignalREvent);

            $scope.$on(
                "$destroy",
                function () {
                    destroyGrid();
                    //centreOverviewUpdatesService.onOrderItemChanged(null);
                    //centreOverviewUpdatesService.onNewOrderItem(null);
                    //centreOverviewUpdatesService.onOrderChanged(null);
                }
            );
        }

        function checkCurrentUserPermissions() {
            return $q.when($scope.user) //we have user already
                .then(function(user) {
                    //Check that current user is a centre user 
                    $scope.permissionsGranted = user && !user.isCustomer();

                    if (!$scope.permissionsGranted) {
                        toastr.error('Sorry, you have no access to this data :(', 'Access denied');
                        $log.error(`User [${user.$model.name}] has no permissions to view Centre [${$scope.centreId}] data.`);
                    }

                    return $scope.permissionsGranted;
                });
        }

        function initPageHeaderAndConfigs() {
            $scope.pageDisplayName = uiLocalization.translate('Centre Overview');

            return centresRepository.getCentre($scope.centreId)
                .then(function(centre) {
                    $scope.centre = centre;

                    $q.all(
                        [
                            gridDataProvider.getGridConfig('all-open'),
                            templateResolver.resolve('app/ui/centre/overview/gridHeader.html'),
                            customResourceResolver.resolveConfig(
                                'centre-profile-open-orders-filter',
                                {
                                    //Default config if nothing resolved from customization configuration files
                                    name: $scope.centre.$model.code,
                                    color: 'green',
                                    queryForStatInfo:
                                        `OrderItem.Deleted = false AND Step.Code <> 'Complete' AND Step.Code <> 'Cancelled' AND (Centre.Id = ${
                                            $scope.centreId} OR AssignedCentre.Id = ${$scope.centreId})`,
                                    targetUri: `#/client/centres/${$scope.centreId}/overview`,
                                    iconName: 'track',
                                    uiPriority: 1
                                },
                                {
                                    //Context data for the customized config
                                    centreId: $scope.centreId,
                                    centreCode: $scope.centre.$model.code
                                }),
                            initCentreTabs()
                        ]
                    ).then(function(data) {
                        var gridConfig = _.clone(data[0]);
                        $scope.gridHeaderTemplate = data[1];
                        var gridOrdersCustomFilter = data[2];

                        //Set our custom filter config onto order items grid shared settings object,
                        //so grid data provider will get us the orders according to this custom filter OMQL query
                        //for all open orders, instead of expecting us to request orders for particular step
                        orderItemsGridSharedSettings.setCustomFilter(gridOrdersCustomFilter);
                        orderItemsGridSharedSettings.setStepFilter("all-open"); //to set other grid behaviour settings equal to 'all-open' filter

                        //Set config onto orderitems grid wrapper directive so it will configure and render itself
                        gridConfig = initGridConfig(gridConfig, $scope.gridHeaderTemplate);
                        gridConfig.dataSource = initGridDataSource(gridConfig);
                        $scope.gridConfig = gridConfig;

                        if ($scope.centre) {
                            $scope.pageDisplayName = uiLocalization.translate("Centre: %s", $scope.centre.$model.address.$model.companyName);
                            $rootScope.pageTitle = uiLocalization.translate("OrderManager: Centre: %s", $scope.centre.$model.address.$model.companyName);
                        }
                    });
                });
        }

        function initCentreTabs() {
            $scope.tabs = [
                {
                    title: gettext("Orders in Progress"),
                    name: "ordersList"
                }
            ];

            return customResourceResolver.resolveConfig('centre-profile-additional-tabs', [])
                .then(function (customTabs) {
                    if (customTabs && customTabs.length > 0) {
                        customTabs.forEach(function(t) {
                            $scope.tabs.push(t);
                        });
                    }

                    setCurrentTab($scope.tabs[0]);
            });
        }

        function setCurrentTab(tab) {
            $scope.currentTab = tab;

            //TODO: Implement saving current tab for user into userSettings
        }

        function getCentreStatistics() {
            var filterQuery = null;

            //TODO: Think on applying more filters
            return $q.all([workflowRepository.getSteps(), customResourceResolver.resolveWorkflow()])
                .then(function (data) {
                    var steps = data[0];
                    var workflowConfig = data[1];

                    var getOpenOrdersStats = centresRepository
                        .getCentreOrdersStepsStats($scope.centreId, filterQuery)
                        .then(function (stats) {
                            //A bit of mapping/pre-processing before we return all orders counts per workflow stage
                            //so we can render later all values (if necessary) even for the workflow stages with 0 items
                            var stepsWithStats = _.map(steps,
                                function (step) {
                                    var statValue = stats.find(function (stat) { return stat.step === step.$model.code });
                                    return { step: step, stat: statValue ? statValue : { numOrderItems: 0, numOrders: 0} }
                                });

                            return stepsWithStats;
                        });

                    var getCentreUsersStats = centresRepository
                        .getCentreUsersStats($scope.centreId, $scope.usersStatsFrom, $scope.usersStatsTo);

                    return $q.all([getOpenOrdersStats, getCentreUsersStats]);
                })
                .then(function (data) {
                    processCentreStatistics(data[0], data[1]);
                });
        }

        function processCentreStatistics(stepsWithStats, usersStats) {
            if (stepsWithStats) {
                //Calculate totals
                var ordersTotals = {
                    //Total order items count at all steps/stages
                    total: _.reduce(stepsWithStats, function(memo, sws) {
                         return memo + sws.stat.numOrderItems;
                    }, 0),
                    //Non completed orders/items
                    open: _.reduce(stepsWithStats, function(memo, sws) {
                         return memo + (sws.step.$model.type !== 2 ? sws.stat.numOrderItems : 0);
                    }, 0),
                    //Completed orders items
                    completed: _.reduce(stepsWithStats, function(memo, sws) {
                        return memo +
                            (sws.step.$model.type === 2 && sws.step.$model.code.toLowerCase().indexOf('cancel') === -1 ? sws.stat.numOrderItems : 0);
                    }, 0),
                    //Completed orders items
                    cancelled: _.reduce(stepsWithStats, function (memo, sws) {
                        return memo +
                            (sws.step.$model.type === 2 && sws.step.$model.code.toLowerCase().indexOf('cancel') !== -1 ? sws.stat.numOrderItems : 0);
                    }, 0)
                };

                //And assign to variables bound to UI
                $scope.$applyAsync(function () {
                    $scope.centreStepsStats = stepsWithStats;
                    $scope.ordersTotals = ordersTotals;

                    initStepsChartData();

                    checkIfActiveCentre();
                });
            }

            if (usersStats) {
                //And assign to variables bound to UI
                $scope.$applyAsync(function () {
                    $scope.centreUsersStats = usersStats;

                    initUsersStatsChartData();
                });
            }
        }

        function checkIfActiveCentre() {
            $scope.isActiveCentre = $scope.ordersTotals && $scope.ordersTotals.open && $scope.ordersTotals.open !== 0;
        }

        function initStepsChartData() {
            if (!$scope.centreStepsStats) {
                return;
            }

            $scope.chartData = [
                {
                    key: "Orders per workflow step",
                    values: _.map(
                        $scope.centreStepsStats.filter(function (ss) { return ss.stat.numOrderItems > 0 && ss.step.$model.type !== 2; }), //ignore 0 items steps and 'end' steps
                        function (sws) {
                            return {
                                label: serverLocalization.translate(sws.step.$model.nameResource),
                                value: sws.stat.numOrderItems
                            };
                        })
                }
            ];

            $scope.chartOptions = {
                chart: {
                    type: 'discreteBarChart',
                    height: 250,
                    margin: { top: 10, right: 5, bottom: 70, left: 0 },
                    x: function (d) { return d.label; },
                    y: function (d) { return d.value; },
                    forceY: [0, 10],
                    //useInteractiveGuideline: true,
                    showValues: true,
                    staggerLabels: $scope.chartData[0].values.length > 6,
                    wrapLabels: true,
                    noData: gettext('No orders data available'),
                    valueFormat: function (d) { return d3.format('~g')(d); },
                    duration: 500,
                    showYAxis: true,
                    tooltip: {
                        valueFormatter: function(d) {
                            return d > 1
                                ? uiLocalization.translate("%s Items", d3.format('~g')(d))
                                : uiLocalization.translate("%s Item", d3.format('~g')(d));
                        }
                    }
                }
            };
        }

        function initUsersStatsChartData() {
            if (!$scope.centreUsersStats) {
                return;
            }

            $scope.chartUsersStatsData = [
                {
                    key: "Centre Users Stats",
                    values: _.map(
                        $scope.centreUsersStats,
                        function (cus) {
                            return {
                                label: cus.userName,
                                value: cus.workflowActionsExecutions
                            };
                        })
                }
            ];

            $scope.chartUsersStatsOptions = {
                chart: {
                    type: 'discreteBarChart',
                    height: 250,
                    margin: { top: 10, right: 5, bottom: 70, left: 30 },
                    x: function (d) { return d.label.length > 16 ? (d.label.slice(0, 13) + '...') : d.label; },
                    y: function (d) { return d.value; },
                    forceY: [0, 10],
                    //useInteractiveGuideline: true,
                    showValues: false,
                    //staggerLabels: $scope.chartData[0].values.length > 6,
                    rotateLabels: -35,
                    wrapLabels: false,
                    noData: gettext('No user statistics available'),
                    valueFormat: function (d) { return d3.format('s')(d); },
                    duration: 500,
                    xAxis: {
                        tickPadding: -7
                    },
                    showYAxis: true,
                    yAxis: {
                        //axisLabel: gettext('Workflow Actions Performed'),
                        tickFormat: function(d) {
                            return d3.format('s')(d);
                        },
                        axisLabelDistance: 0,
                        showMaxMin: false
                    },
                    tooltip: {
                        valueFormatter: function (d) {
                            return d > 1
                                ? uiLocalization.translate("Performed %s workflow actions", d3.format('s')(d))
                                : uiLocalization.translate("Performed %s workflow action", d3.format('s')(d));
                        }
                    }
                }
            };
        }

        function viewUsersActivityLastYear() {
            $scope.usersStatsTo = new Date();
            $scope.usersStatsFrom = new Date($scope.usersStatsTo.getFullYear(), $scope.usersStatsTo.getMonth() - 12, $scope.usersStatsTo.getDate());
            $scope.userStatsChartType = UsersStatsChartTypes.year;

            $scope.isUserStatsBusy = true;

            centresRepository.getCentreUsersStats($scope.centreId, $scope.usersStatsFrom, $scope.usersStatsTo)
                .then(function(usersStats) {
                    processCentreStatistics(null, usersStats);

                    $scope.isUserStatsBusy = false;
                });
        }

        function viewUsersActivityLastMonth() {
            $scope.usersStatsTo = new Date();
            $scope.usersStatsFrom = new Date($scope.usersStatsTo.getFullYear(), $scope.usersStatsTo.getMonth() - 1, $scope.usersStatsTo.getDate());
            $scope.userStatsChartType = UsersStatsChartTypes.month;

            $scope.isUserStatsBusy = true;

            centresRepository.getCentreUsersStats($scope.centreId, $scope.usersStatsFrom, $scope.usersStatsTo)
                .then(function (usersStats) {
                    processCentreStatistics(null, usersStats);

                    $scope.isUserStatsBusy = false;
                });
        }

        function viewUsersActivityLastWeek() {
            $scope.usersStatsTo = new Date();
            $scope.usersStatsFrom = new Date().addDays(-7);
            $scope.userStatsChartType = UsersStatsChartTypes.week;

            $scope.isUserStatsBusy = true;

            centresRepository.getCentreUsersStats($scope.centreId, $scope.usersStatsFrom, $scope.usersStatsTo)
                .then(function (usersStats) {
                    processCentreStatistics(null, usersStats);

                    $scope.isUserStatsBusy = false;
                });
        }

        function getAddressGeocodingData() {
            if ($scope.centre) {
                geocodingService.getGeocodingForAddress($scope.centre.$model.address.toFormattedString())
                    .then(function (result) {
                        $scope.centreAddressPlace = result;
                    });
            }
        }

        //

        function initAdditionalFilter() {
            $scope.searchDropdownOptions = {
                dataSource: [
                    { text: gettext("Regular Search"), value: "reg-search", icon: "search-dropdown-icon icon-magnifier-add" },
                    { text: gettext("Exact Match Search"), value: "exact-search", icon: "search-dropdown-icon icon-magnifier" }
                ],
                valuePrimitive: false,
                dataTextField: "text",
                dataValueField: "value",
                valueTemplate: ' ',
                template: '<span class="k-state-default"><i class="{{dataItem.icon}} pull-left"></i>' +
                    '<span>{{dataItem.text}}</span></span>',
                dataBound: function () {
                    this.list.width("auto");
                }
            };

            $scope.clearSearchTerm = function () {
                orderItemsGridSharedSettings.setTextSearch(null);
                $scope.textSearch = null;
                applyTextSearch();
            };

            var textSearchConfig = orderItemsGridSharedSettings.getTextSearch();
            if (textSearchConfig) {
                $scope.textSearch = textSearchConfig.text;
                $scope.searchDropdown = textSearchConfig.exact ? "exact-search" : "reg-search";
            } else {
                $scope.textSearch = null;
                $scope.searchDropdown = "reg-search";
            }
        }

        function initGrid() {
            angular.element($window).bind('resize', function () {
                resizeGrid();

                // manual $digest required as resize event
                // is outside of angular
                $scope.$digest();
            });

            var gridTemplate = '<div id="orderItemsGrid" kendo-grid="orderItemsGrid" k-options="gridConfig" class="all-open-grid k-grid-content"></div>';
            var jqTemplate = $('#orderItemsKendoGrid').append(gridTemplate);
            $compile(jqTemplate)($scope);

            //Init all the handlers for the events of the grid (like row click, checkbox-selector click, ,double-click, etc.
            initGridEventsHandlers($scope.gridConfig);

            //Trigger window resize event to properly resize grid
            $timeout(function () { $(window).trigger('resize'); });

        }

        function initGridConfig(gConfig, gridHeaderTemplate) {

            gConfig.hideShowCompletedSwitch = true;

            if (gConfig.columns) {
                var firstVisibleColumn = _.find(gConfig.columns, function (c) {
                    return !c.hidden && c.field;
                });
                if (firstVisibleColumn) {
                    firstVisibleColumn.template = _.string.sprintf(
                        "<div style='white-space:nowrap;'><a title='%s' class='fa fa-lg fa-ellipsis-v a-fa-btn details-btn pull-left' ng-click='showStepDetails()'></a><span>#:%s#</span></div>",
                        gettext("View Details"),
                        firstVisibleColumn.field);
                }

                //Check if we have columns without percentage specified. Assign width if so.
                for (var i = 0; i < gConfig.columns.length; i++) {
                    var column = gConfig.columns[i];
                    if (!column.width) {
                        column.width = 2 * (100 / gConfig.columns.length) + "%";
                    }
                }
            }

            gConfig.toolbar = [{ template: gridHeaderTemplate }];

            gConfig.noRecords = {
                template: gettext("No items to display")
            };

            gConfig.dataBound = function (e) {
                //Execute the dataBound defined on the customised config first 
                if (angular.isDefined($scope.gridConfig.dataBoundEventHandler) && angular.isFunction($scope.gridConfig.dataBoundEventHandler)) {
                    try {
                        $scope.gridConfig.dataBoundEventHandler.call($scope.orderItemsGrid, e);
                    } catch (error) {
                        $log.error("Error during executing customised Grid's config's DataBound even handler.", error);
                    }
                }

                //And highlight the searchTerm found in the text values inside rows shown
                $timeout(function () {
                    if (!String.isNullOrWhiteSpace($scope.textSearch)) {
                        $("#orderItemsKendoGrid tbody td[role='gridcell']").highlight($scope.textSearch);
                    } else {
                        $("#orderItemsKendoGrid tbody td[role='gridcell']").unhighlight();
                    }
                });
            };

            //Grid pager is 'ON' by default or if specified so
            if (!gConfig.pageable || typeof gConfig.pageable === 'boolean' || gConfig.pageable !== null) {
                //Pager info (items count) is 'ON' by defaults unless specified to be 'OFF'
                var disablePagerInfo = gConfig.disablePagerItemsInfo && gConfig.disablePagerItemsInfo === true;
                if (disablePagerInfo) {
                    //Reset pageable object. Otherwise just not touch it as it contains other valuable settings
                    gConfig.pageable = {
                        refresh: true,
                        pageSizes: true,
                        info: !disablePagerInfo
                    };
                }
            }

            //See if we have default sorting specified, then set it onto grid shared settings
            if (angular.isDefined(gConfig.initialSort)) {
                if (angular.isArray(gConfig.initialSort)) {
                    orderItemsGridSharedSettings.setGridSort(gConfig.initialSort);
                } else if (angular.isDefined(gConfig.initialSort.field) && angular.isDefined(gConfig.initialSort.dir)) {
                    orderItemsGridSharedSettings.setGridSort([gConfig.initialSort]);
                }
            }

            return gConfig;
        }

        var forcedPageChange = false;
        var cachedResult;

        function initGridDataSource(gridConfig) {
            var dataSourceObj = {
                transport: {
                    read: function (options) {
                        if (forcedPageChange) { // prevent data request after manual page change
                            forcedPageChange = false;
                            if (cachedResult) {
                                options.success(cachedResult);
                            } else {
                                toastr.error(gettext("Data request cache error"));
                                options.error();
                            }
                            return;
                        }
                        $scope.isBusy = true;
                        $scope.isGridReload = true;

                        //Reset page size ignorance flag as it shouldn't alter grid behavior.
                        //It is applied only on the item details card if order item id specified in the url as a parameter
                        orderItemsGridSharedSettings.setForceIgnorePageSize(false);

                        orderItemsGridSharedSettings.setPageNumber(options.data.page || 1);
                        orderItemsGridSharedSettings.setPageSize(angular.isDefined(options.data.pageSize) ? options.data.pageSize : 20);
                        orderItemsGridSharedSettings.setGridFilter(options.data.filter);
                        orderItemsGridSharedSettings.setGridSort(options.data.sort);

                        renderSkeletonPlaceholdersLoadingAnimation();

                        gridDataProvider.getData()
                            .then(function (result) {
                                orderItemsGridSharedSettings.setTotalCount(result.totalCount);
                                orderItemsGridSharedSettings.setTotalPageCount(result.totalPageCount);
                                cachedResult = result;
                                dataRequestCount++;

                                // check if current page number was changed
                                if ($scope.gridConfig.dataSource.page() !== result.pageNumber ||
                                    $scope.gridConfig.dataSource.pageSize() !== result.rowsPerPage) {
                                    forcedPageChange = true;
                                    options.page = result.pageNumber;
                                    options.pageSize = result.rowsPerPage;
                                    $scope.gridConfig.dataSource.query(options);
                                }

                                if (!$scope.selectedOrderItemId) {
                                    $scope.selectedOrderItemId = orderItemsGridSharedSettings.getSelectedOrderItemId();
                                }

                                clearSkeletonPlaceholdersLoadingAnimation();

                                options.success(result);
                                $scope.isBusy = false;
                                $scope.isGridReload = false;
                                textSearchTrigger = false;

                                resizeGrid();
                            },
                                function (resp) {
                                    if (resp && resp.status) {
                                        toastr.error(resp.message, gettext("Reading orders data failed"));
                                    } else {
                                        toastr.error(gettext("Reading orders data failed"), gettext("Server is not responding"));
                                    }
                                    options.error();
                                    $scope.isBusy = false;
                                    $scope.isGridReload = false;
                                    textSearchTrigger = false;
                                });
                    }
                },
                schema: {
                    data: function (response) {
                        return response ? response.items : null;
                    },
                    total: function (response) {
                        return response ? response.totalCount : 0;
                    },
                    model: {
                        id: "$model.id",
                        fields: gridConfig.fields || {}
                    }
                },
                page: orderItemsGridSharedSettings.getPageNumber() || 1,
                pageSize: orderItemsGridSharedSettings.getPageSize() || gridConfig.pageSize || 20,
                filter: orderItemsGridSharedSettings.getGridFilter(),
                sort: orderItemsGridSharedSettings.getGridSort(),
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true
            };

            if (gridConfig.groupable === true && angular.isDefined(gridConfig.initialGroup)) {
                dataSourceObj.group = gridConfig.initialGroup;
                dataSourceObj.pageSize = gridConfig.pageSize;
            }

            return new kendo.data.DataSource(dataSourceObj);
        }

        function initGridEventsHandlers(gConfig) {
            //double click event to allow user to open order details
            $("#orderItemsKendoGrid tbody[role='rowgroup']").on("dblclick", "tr", function () {
                showStepDetails();
            });
        }

        /**
         * Updates busy state
         */
        function setBusyState(newBusyState) {
            $scope.isBusy = newBusyState;
        }

        function applyTextSearch() {
            orderItemsGridSharedSettings.setTextSearch($scope.textSearch, $scope.searchDropdown === "exact-search");
            reloadGrid();
            textSearchTrigger = true;
        }

        /**
         * Get selected items from grid
         * @returns {!RepresentationModel[]}
         */
        function getSelectedEntities() {
            var selectedEntities = [];
            var selectedDOM = $scope.orderItemsGrid.select();
            _.forEach(selectedDOM, function (value) {
                selectedEntities.push($scope.orderItemsGrid.dataItem(value));
            });
            return selectedEntities;
        }

        function showStepDetails() {
            var selected = getSelectedEntities();
            if (!selected || $scope.forbidOrderDetailsView) {
                //Do not allow to go into step details if nothing selected
                //OR if we are requested to do so according to the customisation configs
                return;
            }
            var firstSelected = selected[0];
            if (firstSelected && firstSelected.isRepresentationModel) {
                orderItemsGridSharedSettings.setSelectedOrderItemId(firstSelected.getId());
                // go to the Step Details View
                $state.go('client.step', {
                    step: $scope.step
                });
            }
        }

        function renderSkeletonPlaceholdersLoadingAnimation() {
            if ($('#orderItemsKendoGrid table tbody').children().length > 0 || $('#orderItemsKendoGrid div.k-grid-norecords').length > 0) {
                //Do not render skeleton loading placeholders if we do have records to show OR if instead there are no records to show and we alreayd know it
                return;
            }

            var pageSize = orderItemsGridSharedSettings.getPageSize();
            if (!angular.isDefined(pageSize)) {
                pageSize = $scope.gridConfig.pageSize;
            }

            if (pageSize === 0 || pageSize > 15) {
                pageSize = 15; //Set page size for the loading-placeholders content to 15 if it's configured for bigger value or 0 which is 'show all'
            }

            var columnsCount = 10; //10 by default but it's better to try and find the columns count from grid template
            //which is initialised based on the grid branded config
            if ($('#orderItemsKendoGrid table colgroup').length > 0) {
                columnsCount = $('#orderItemsKendoGrid table colgroup').children().length;
            }
            for (var i = 0; i < pageSize; i++) {

                //Render visual templates to indicate loading rows/cells
                var row = $('<tr></tr>');
                for (var c = 0; c < columnsCount; c++) {
                    var divWidth = c > 0 ? (40 + Math.floor(Math.random() * 60)) : 100;
                    row.append($('<td class="loading-td"><div style="width:' + divWidth + '%;"></div></td>'));
                }
                $('#orderItemsKendoGrid table tbody').append(row);

            }
        }

        function clearSkeletonPlaceholdersLoadingAnimation() {
            $('#orderItemsKendoGrid table tbody').empty();
        }

        function resizeGrid() {
            var availableHeight = $(window).height() - $("div.grid-view-title").outerHeight(true) - $("div.centre-info").outerHeight(true) 
                - $("div.k-grid-toolbar").outerHeight(true) - $("thead.k-grid-header").outerHeight(true) - $("div.k-grouping-header").outerHeight(true)
                - $("div.k-grid-pager").outerHeight(true) - $("#header").outerHeight(true)
                - $(".centre-tabs-links").outerHeight(true)
                - parseFloat($(".centre-tabs-container").css('margin-top'));

            $('#orderItemsKendoGrid table').css("height", availableHeight);
        }

        /**
         * Force grid to refresh (if loaded)
         */
        function reloadGrid() {

            if ($scope.orderItemsGrid && $scope.orderItemsGrid.dataSource && $scope.orderItemsGrid.dataSource.read) {
                $('thead tr').find('input[type=checkbox]').prop('checked', false);
                $('thead tr').find('input[type=checkbox]').prop('indeterminate', false);

                return $scope.orderItemsGrid.dataSource.read();
            }

            return $q.when(null);
        }

        function destroyGrid() {
            if (!$scope.orderItemsGrid || !$scope.orderItemsGrid.destroy) {
                return;
            }
            $scope.orderItemsGrid.destroy();
        }

        /**
         * Reports DropDown initialization
         * @returns {Promise}
         */
        function initReportList() {
            return reportManager.getReportListByName('all-open', 'centre-profile-orders-grid-reports')
                .then(function (results) {
                    var reportComboItems = [];
                    _.forEach(results, function (value) {
                        reportComboItems.push({ "text": value.name, "value": value });
                    });
                    $scope.dropdownReportsOptions = {
                        index: undefined,
                        dataSource: reportComboItems,
                        dataTextField: "text",
                        dataValueField: "value",
                        height: "auto",
                        valueTemplate: gettext("Reports"),
                        template: "<span class='k-state-default'  # if (!!data.value.requiresSelection) { # ng-class='{\"k-state-disabled\": selectedOrderItemId == null}' # } #><span>{{dataItem.text|sTranslate}}</span></span>",
                        select: function (e) {
                            gridDataProvider.getReportQuery() //acquire the current query used to populate the grid
                                .then(function (gridQuery) {
                                    var report = $scope.dropdownReportsOptions.dataSource[e.item.index()]; //get the clicked report configuration
                                    var selectedItemId = orderItemsGridSharedSettings.getSelectedOrderItemId(); //see if we have a selected item

                                    if (!!report.value.requiresSelection) {
                                        if (angular.isDefined(selectedItemId)) {
                                            //we use the selected item id as a query for the report if we have one selected
                                            reportManager.show({ report: report.value, query: [selectedItemId], orderBy: report.value.orderBy || gridQuery.orderBy });
                                        }
                                        //do nothing if report requires selection and we don't have any item selected
                                    } else {
                                        //If report doesn't require selection, use either specific custom query of the report (report.value.query)
                                        //specified in customisation or just the query that is used to show the current data set (gridQuery.query)
                                        //user is being viewing at.
                                        //Query and orderBy from report specified in customisation have higher priority over current-context data.
                                        reportManager.show({
                                            report: report.value,
                                            //Now supply the query to the report manager. Here we check if the report was configured with static query,
                                            //dynamic (function) query or no query at all. If it is a dynamic query - we use it, otherwise we use static query.
                                            //In case no query was configured in the report configuration section, we just use the grid's query to generate
                                            //report for exactly the same items we see in the grid.
                                            query: angular.isFunction(report.value.query)
                                                ? report.value.query(gridQuery, $scope.selectedOrderItem) : (report.value.query || gridQuery.query), orderBy: report.value.orderBy || gridQuery.orderBy
                                        });
                                    }
                                });
                        },
                        dataBound: function () {
                            this.list.width('auto');
                        }
                    };
                }, function (error) {
                    $log.error("Can't initialize report list: ");
                    if (error && error.message) {
                        $log.error(error.message);
                    } else if (error && _.isString(error)) {
                        $log.error(error);
                    } else {
                        $log.error("Unknown error");
                    }
                });
        }

    })
    // Separate service for update events (to prevent multiple event subscription)
    .service('centreOverviewUpdatesService', function (rest) {
        var _this = this;
        var newOrderItemCb;
        var orderItemChangedCb;
        var orderChangedCb;

        rest.events.on("modelCreatedOnServer", function (modelInfo) {
            if (!newOrderItemCb) {
                return;
            }
            if (modelInfo && modelInfo.modelType === "OrderItemModel") {
                newOrderItemCb(modelInfo);
            }
        });

        rest.events.on("modelUpdatedOnServer", function (modelInfo) {
            if (modelInfo.modelType === "OrderItemModel" && orderItemChangedCb) {
                orderItemChangedCb(modelInfo);
            } else if (modelInfo.modelType === "OrderModel" && orderChangedCb) {
                orderChangedCb(modelInfo);
            }
        });

        _this.onNewOrderItem = function (cb) {
            newOrderItemCb = cb;
        };

        _this.onOrderItemChanged = function (cb) {
            orderItemChangedCb = cb;
        };

        _this.onOrderChanged = function (cb) {
            orderChangedCb = cb;
        };

        return _this;
    })
 ;
